import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/components/ui/card';

export function Placeholder({
  title,
  subtitle,
  description,
  children,
}: {
  title: string;
  subtitle?: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className="h-full space-y-6 overflow-y-auto">
      <div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Pendiente de implementación</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent>
          {children ?? (
            <p className="text-sm text-muted-foreground">
              Este módulo será portado en una fase posterior.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
